import { render } from "./media-msg-box.vue?vue&type=template&id=3853afd4&scoped=true&ts=true"
import script from "./media-msg-box.vue?vue&type=script&lang=ts"
export * from "./media-msg-box.vue?vue&type=script&lang=ts"

import "./media-msg-box.vue?vue&type=style&index=0&id=3853afd4&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3853afd4"]])

export default __exports__